import { initMessaging } from './base';
import { CALL_API } from './middlewares/api';
import { Step } from './modules/guiaInterativo/constants';

import moment from 'moment';

const logError = value => ({
  [CALL_API]: {
    type: 'LOG_ERROR',
    endpoint: 'errors',
    autheticated: false,
    config: {
      method: 'POST',
      body: {
        ...value,
        // MAX_SAFE_INTEGER = 9007199254740991
        token: parseInt(moment().format("QMMSSSssDDmmHHYY"), 10)
      }
    }
  },
  value
});

const forcarAbrirGuia = value => ({
  type: 'ABRIR_GUIA_INTERATIVO',
  value
});

const abrirGuia = (value = Step.INICIO) => (dispatch, getState) => {
  if (getState().guiaInterativo.run) {
    dispatch(encerrarGuia());
  }
  dispatch(forcarAbrirGuia(value));
};

const abrirGuiaSeNecessario = stepIndex => (dispatch, getState) => {
  if (getState().guiaInterativo.run) {
    dispatch(forcarAbrirGuia(stepIndex));
  }
};

const encerrarGuia = () => ({
  type: 'ENCERRAR_GUIA_INTERATIVO'
});

const sendMessagingToken = dispatch => value => {
  dispatch({
    [CALL_API]: {
      type: 'SEND_MESSAGING_TOKEN',
      endpoint: 'messaging',
      authenticated: true,
      config: {
        method: 'POST',
        body: {
          token: value
        }
      }
    },
    value
  });
};

export const enableMessaging = () => dispatch => {
  initMessaging.init(dispatch(sendMessagingToken));
};

export default {
  abrirGuia,
  abrirGuiaSeNecessario,
  encerrarGuia,
  logError,
  enableMessaging
};



// WEBPACK FOOTER //
// ./src/actions.js